import {SearchComboboxHistoryIcon} from "@pg-design/search-combobox-module";

import {PricesSearchBuildingIcon} from "./icons/PricesSearchBuildingIcon";
import {PricesSearchLocationIcon} from "./icons/PricesSearchLocationIcon";
import {PricesSearchMapIcon} from "./icons/PricesSearchMapIcon";
import {PricesSearchPinIcon} from "./icons/PricesSearchPinIcon";
import {PricesSearchStreetIcon} from "./icons/PricesSearchStreetIcon";

export type PricesSearchIconKind = "city" | "district" | "street" | "address" | "number" | "nearby" | "recent";

interface IProps {
    kind: PricesSearchIconKind;
}

/** Glyph of the 40×40 row tile: what the row is, the history clock for recent searches. */
export const PricesSearchTypeIcon = (props: IProps) => {
    switch (props.kind) {
        case "recent":
            return <SearchComboboxHistoryIcon />;
        case "city":
            return <PricesSearchBuildingIcon />;
        case "district":
            return <PricesSearchMapIcon />;
        case "street":
            return <PricesSearchStreetIcon />;
        case "nearby":
            return <PricesSearchLocationIcon />;
        case "address":
        case "number":
            return <PricesSearchPinIcon />;
    }
};
import {SearchComboboxHistoryIcon} from "@pg-design/search-combobox-module";

import {PricesSearchBuildingIcon} from "./icons/PricesSearchBuildingIcon";
import {PricesSearchLocationIcon} from "./icons/PricesSearchLocationIcon";
import {PricesSearchMapIcon} from "./icons/PricesSearchMapIcon";
import {PricesSearchPinIcon} from "./icons/PricesSearchPinIcon";
import {PricesSearchStreetIcon} from "./icons/PricesSearchStreetIcon";

export type PricesSearchIconKind = "city" | "district" | "street" | "address" | "number" | "nearby" | "recent";

interface IProps {
    kind: PricesSearchIconKind;
}

/** Glyph of the 40×40 row tile: what the row is, the history clock for recent searches. */
export const PricesSearchTypeIcon = (props: IProps) => {
    switch (props.kind) {
        case "recent":
            return <SearchComboboxHistoryIcon />;
        case "city":
            return <PricesSearchBuildingIcon />;
        case "district":
            return <PricesSearchMapIcon />;
        case "street":
            return <PricesSearchStreetIcon />;
        case "nearby":
            return <PricesSearchLocationIcon />;
        case "address":
        case "number":
            return <PricesSearchPinIcon />;
    }
};
